import { render, staticRenderFns } from "./viplist.vue?vue&type=template&id=474c68c1&scoped=true&"
import script from "./viplist.vue?vue&type=script&lang=js&"
export * from "./viplist.vue?vue&type=script&lang=js&"
import style0 from "./viplist.vue?vue&type=style&index=0&id=474c68c1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c68c1",
  null
  
)

export default component.exports